'use strict';

const inspectable = require('../rlink-inspectable-error');
const isPlainObject = require('../rlink-type-utils/isPlainObject');

function isStoreSetAction (value) {
  return isPlainObject(value) && value.isStoreSetAction;
}

module.exports = function areStoreSetActions (values) {
  if (values.some(v => isStoreSetAction(v))) {
    if (!values.every(v => isStoreSetAction(v))) {
      throw inspectable`Inconsistent ${{ values }} - at least one value is an EmbeddedValue but some are not!`;
    }
    return true;
  }

  return false;
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/areStoreSetActions.js